import React, { FC, useCallback, useState } from 'react';
import { Solution } from '../../../../../../config/api/models/Solutions';
import { useTranslation } from 'react-i18next';
import { Solutions } from './Solutions';
import {
  AttemptLabel,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
} from './Atoms';
import { useTheme } from '@material-ui/core';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';

type StudentSolutionProps = {
  solution: Solution;
};

export const StudentSolution: FC<StudentSolutionProps> = ({ solution }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [expanded, setExpanded] = useState<boolean>(false);
  const handleChange = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  return (
    <StyledAccordion onChange={handleChange}>
      <StyledAccordionSummary>
        <AttemptLabel>
          <FontAwesomeSpriteIcon
            icon={expanded ? SpriteIconsLight.ANGLE_UP : SpriteIconsLight.ANGLE_DOWN}
            color={theme.palette.text.primary}
            iconSize="md"
          />
          {t('trajectory.sections.shared.solutions.title')}
        </AttemptLabel>
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <Solutions solution={solution} inAccordion />
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
